export { replaceUrlPrefix } from './src/utils';
import OEMManager from './src/OEMManager/OEMManager';

/**
 * OEMManager instance
 * */
const oemManager = new OEMManager();

export default oemManager;
